// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantAccountActivityMultiEmployersSummaryRecordDto
 */
export interface IParticipantAccountActivityMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    num_active?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    num_canceled?: number;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    total?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivityMultiEmployersSummaryRecordDto
     */
    total_claim_spend?: number;
}

/**
 * Check if a given object implements the IParticipantAccountActivityMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIParticipantAccountActivityMultiEmployersSummaryRecordDto(value: object): value is IParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return true;
}

export function IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSON(json: any): IParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IParticipantAccountActivityMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantAccountActivityMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'num_active': json['num_active'] == null ? undefined : json['num_active'],
        'num_canceled': json['num_canceled'] == null ? undefined : json['num_canceled'],
        'total': json['total'] == null ? undefined : json['total'],
        'total_claim_spend': json['total_claim_spend'] == null ? undefined : json['total_claim_spend'],
    };
}

export function IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSON(json: any): IParticipantAccountActivityMultiEmployersSummaryRecordDto {
    return IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IParticipantAccountActivityMultiEmployersSummaryRecordDtoToJSONTyped(value?: IParticipantAccountActivityMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_type': value['account_type'],
        'num_active': value['num_active'],
        'num_canceled': value['num_canceled'],
        'total': value['total'],
        'total_claim_spend': value['total_claim_spend'],
    };
}

